import { render, staticRenderFns } from "./reorder.vue?vue&type=template&id=1736c826&scoped=true"
import script from "./reorder.vue?vue&type=script&lang=js"
export * from "./reorder.vue?vue&type=script&lang=js"
import style0 from "./reorder.vue?vue&type=style&index=0&id=1736c826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1736c826",
  null
  
)

export default component.exports